import React, { useEffect, useState } from "react";
import { Button, Spinner } from "@material-tailwind/react";
import { FaPlusCircle, FaTrash } from "react-icons/fa";
import { getAllProductsApi } from "api/products";

// combox
import { Combobox } from "@headlessui/react";
import { updateStockApi } from "api/stock";
import { updateStockAvoirApi } from "api/stock";
import { getAllStockEntryByLotNumberApi } from "api/stockEntry";

function TransfertForm({ closePopup, depotFormAction, showToast }) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedProductsList, setSelectedProductsList] = useState([
    {
      Product: "",
      FromD: null,
      ToD: null,
      Quantity: 0,
      LotNumber: "",
    },
  ]);

  const [transfertComment, setTransfertComment] = useState("");
  const [transfertType, setTransfertType] = useState("");

  // combox
  const [selectedComboBoxData, setSelectedComboBoxData] = useState("");
  const [query, setQuery] = useState("");
  const [comboBoxData, setComboBoxData] = useState([]);
  
  // Store lot numbers data for each product (by product Code)
  const [productLotNumbersData, setProductLotNumbersData] = useState({});

  useEffect(() => {
    getAllProducts();
  }, []);

  const filteredComboBoxData =
    query === ""
      ? comboBoxData
      : comboBoxData.filter((value) =>
          value.Name.toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""))
        );

  const handleSelectedComboBoxData = async (e, index) => {
    try {
      const updatedProductsList = [...selectedProductsList];
      updatedProductsList[index].Product = e;
      updatedProductsList[index].LotNumber = ""; // Reset lot number when product changes
      setSelectedProductsList(updatedProductsList);
      
      // Fetch lot numbers for the selected product
      if (e && e !== "") {
        const selectedProduct = comboBoxData.find((el) => el.Name === e);
        if (selectedProduct && selectedProduct.Code) {
          try {
            const lotNumbersRes = await getAllStockEntryByLotNumberApi(selectedProduct.Code);
            
            // Sort by ExperationDate (ascending - earliest expiration first)
            const sortedLotNumbersRes = [...lotNumbersRes].sort((a, b) => {
              // Handle null/undefined expiration dates
              if (!a.ExperationDate && !b.ExperationDate) return 0;
              if (!a.ExperationDate) return 1; // a goes to end
              if (!b.ExperationDate) return -1; // b goes to end
              
              // Convert to Date objects and compare
              const dateA = new Date(a.ExperationDate);
              const dateB = new Date(b.ExperationDate);
              return dateB - dateA; // Ascending order (earliest first)
            });
            
            // Store lot numbers data by product Code
            setProductLotNumbersData(prev => ({
              ...prev,
              [selectedProduct.Code]: sortedLotNumbersRes
            }));
          } catch (err) {
            console.log("Error fetching lot numbers:", err);
            setProductLotNumbersData(prev => ({
              ...prev,
              [selectedProduct.Code]: []
            }));
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleLotNumberChange = (e, index) => {
    try {
      const updatedProductsList = [...selectedProductsList];
      updatedProductsList[index].LotNumber = e.target.value;
      // Reset depots when lot number changes
      updatedProductsList[index].FromD = null;
      updatedProductsList[index].ToD = null;
      setSelectedProductsList(updatedProductsList);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFromDepotChange = (e, index, product) => {
    try {
      const updatedProductsList = [...selectedProductsList];
      const selectedProduct = comboBoxData.find((el) => el.Name === product);
      
      // Get stock from selected lot number if available, otherwise use general product stock
      let stockArray = [];
      if (selectedProduct && selectedProduct.Code && updatedProductsList[index].LotNumber && updatedProductsList[index].LotNumber !== "") {
        const lotNumbers = productLotNumbersData[selectedProduct.Code] || [];
        const selectedLotEntry = lotNumbers.find(
          (entry) => entry.LotNumber === updatedProductsList[index].LotNumber
        );
        if (selectedLotEntry && selectedLotEntry.ProductDetails && selectedLotEntry.ProductDetails[0] && selectedLotEntry.ProductDetails[0].Stock) {
          stockArray = selectedLotEntry.ProductDetails[0].Stock;
        }
      } else if (selectedProduct && selectedProduct.Stock) {
        stockArray = selectedProduct.Stock;
      }

      const fromDObject = stockArray.find((el) => el.City === e.target.value);
      updatedProductsList[index].FromD = fromDObject;
      setSelectedProductsList(updatedProductsList);
    } catch (err) {
      console.log(err);
    }
  };

  const handleToDepotChange = (e, index, product) => {
    try {
      const updatedProductsList = [...selectedProductsList];
      const selectedProduct = comboBoxData.find((el) => el.Name === product);
      
      // Get stock from selected lot number if available, otherwise use general product stock
      let stockArray = [];
      if (selectedProduct && selectedProduct.Code && updatedProductsList[index].LotNumber && updatedProductsList[index].LotNumber !== "") {
        const lotNumbers = productLotNumbersData[selectedProduct.Code] || [];
        const selectedLotEntry = lotNumbers.find(
          (entry) => entry.LotNumber === updatedProductsList[index].LotNumber
        );
        if (selectedLotEntry && selectedLotEntry.ProductDetails && selectedLotEntry.ProductDetails[0] && selectedLotEntry.ProductDetails[0].Stock) {
          stockArray = selectedLotEntry.ProductDetails[0].Stock;
        }
      } else if (selectedProduct && selectedProduct.Stock) {
        stockArray = selectedProduct.Stock;
      }

      const toDObject = stockArray.find((el) => el.City === e.target.value);
      updatedProductsList[index].ToD = toDObject;
      setSelectedProductsList(updatedProductsList);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangeQuantity = (e, index) => {
    try {
      const updatedProductsList = [...selectedProductsList];
      updatedProductsList[index].Quantity = parseFloat(e.target.value);
      setSelectedProductsList(updatedProductsList);
    } catch (err) {
      console.log(err);
    }
  };

  const getAllProducts = async () => {
    try {
      setIsLoading(true);
      const response = await getAllProductsApi("", "", "");
      setComboBoxData([...response]);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelOp = () => {
    try {
      closePopup("Close");
    } catch (err) {}
  };

  const handleEditeDepot = async () => {
    try {
      setIsLoading(true)

      const hasDuplicateProductName = (productsList) => {
        const names = new Set();
        for (let i = 0; i < productsList.length; i++) {
          if (names.has(productsList[i].Product)) {
            // Product name is duplicated
            return productsList[i].Product;
          } else {
            names.add(productsList[i].Product);
          }
        }
        // No duplicate product names found
        return false;
      };

      const errorList = [];
      const stockObject = [];

      if (hasDuplicateProductName(selectedProductsList)) {
        errorList.push(
          `Le produit ${hasDuplicateProductName(
            selectedProductsList
          )} et dupliquée`
        );
      }

      console.log('Numéro de lot', selectedProductsList)

      selectedProductsList.map((el) => {
        if (!el.Product || el.Product === "") {
          errorList.push(`Choisir votre produit`);
        }

        // Require lot number when the product has lot entries available (same UX as stock info modal)
        const selectedProduct = comboBoxData.find(
          (product) => product.Name === el.Product.trim()
        );
        const lotNumbersForProduct =
          selectedProduct && selectedProduct.Code
            ? productLotNumbersData[selectedProduct.Code] || []
            : [];
        if (lotNumbersForProduct.length > 0 && (!el.LotNumber || el.LotNumber === "")) {
          errorList.push(`Sélectionner le numéro de lot pour ${el.Product}`);
        }

        if (!el.FromD || el.FromD === "") {
          errorList.push(`Choisir le depot de d'entrée pour ${el.Product}`);
        }
        if (!el.ToD || el.ToD === "") {
          errorList.push(`Choisir le depot de de sortir pour ${el.Product}`);
        }
        if (!el.Quantity || el.Quantity === 0) {
          errorList.push(`Caissier la quantité de produit ${el.Product}`);
        }
      });

      if (errorList.length !== 0) return showToast("error", errorList[0]);

      selectedProductsList.map((el) => {
        // Get product Code to find lot number data
        const selectedProduct = comboBoxData.find(
          (product) => product.Name === el.Product.trim()
        );
        
        // Get lot number and expiration date if lot number is selected
        let lotNumber = el.LotNumber || "";
        let experationDate = null;
        
        if (selectedProduct && selectedProduct.Code && lotNumber && lotNumber !== "") {
          const lotNumbers = productLotNumbersData[selectedProduct.Code] || [];
          const selectedLotEntry = lotNumbers.find(
            (entry) => entry.LotNumber === lotNumber
          );
          if (selectedLotEntry && selectedLotEntry.ExperationDate) {
            experationDate = selectedLotEntry.ExperationDate;
          }
        }
        
        stockObject.push({
          Name: el.Product,
          FromD: el.FromD.City,
          ToD: el.ToD.City,
          Quantity: el.Quantity,
          Type: "TranfertEntry",
          Comment: transfertComment,
          TransfertType: transfertType,
          LotNumber: lotNumber || null,
          ExperationDate: experationDate || null
        });
      });

      await updateStockApi(stockObject, "save", "true");
      showToast("success", "Transferée");
    } catch (err) {
      if (err?.response?.data)
        showToast("error", `${err?.response?.data?.error}`);
    }
    finally {
      setIsLoading(false)
    }
  };

  const handleAddNewProduct = () => {
    try {
      setSelectedProductsList((prevList) => [...prevList, { 
        Product: "",
        FromD: null,
        ToD: null,
        Quantity: 0,
        LotNumber: ""
      }]);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteProduct = (index) => {
    try {
      const updatedProductsList = [...selectedProductsList];
      updatedProductsList.splice(index, 1);
      setSelectedProductsList(updatedProductsList);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form>
      {isLoading ? (
        <div className="flex w-full items-center justify-center">
          <Spinner className="h-12 w-12" />
        </div>
      ) : (
        <div style={{ height: "30vh", overflowY: "scroll" }}>
          {selectedProductsList.map((el, index) => (
            <div
              style={{
                border: "1px solid #f8eaea",
                padding: "2%",
                borderRadius: "10px",
              }}
              className="mt-2"
            >
              <div className="grid grid-cols-1 gap-5 md:grid-cols-1">
                <div>
                  <label htmlFor="" className="text-md font-bold text-navy-700">
                    sélectionner un produit ({index + 1})
                  </label>

                  <div>
                    <Combobox
                      value={el.Product}
                      onChange={(e) => handleSelectedComboBoxData(e, index)}
                    >
                      <Combobox.Input
                        onChange={(event) => setQuery(event.target.value)}
                        // displayValue={(value) => value.name}
                        className="relative mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none"
                      />
                      <Combobox.Options className="h-32 w-full overflow-y-scroll bg-white">
                        {filteredComboBoxData.map((value) => (
                          <Combobox.Option
                            key={index}
                            value={value.Name}
                            className="cursor-pointer rounded-xl p-2 hover:bg-gray-100"
                          >
                            {value.Name}
                          </Combobox.Option>
                        ))}
                      </Combobox.Options>
                    </Combobox>
                  </div>
                </div>

                {/* Lot Numbers Dropdown */}
                {selectedProductsList[index].Product && (
                  <div className="mt-3">
                    <label htmlFor="" className="text-md font-bold text-navy-700">
                      Numéro de lot
                    </label>
                    <select
                      label="select Lot Number"
                      className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                      disabled={
                        depotFormAction === "show" ||
                        selectedProductsList[index].Product === ""
                      }
                      value={selectedProductsList[index]?.LotNumber || ""}
                      onChange={(e) => handleLotNumberChange(e, index)}
                    >
                      <option value="">Sélectionner le numéro de lot</option>
                      {(() => {
                        const selectedProduct = comboBoxData.find(
                          (el) => el.Name === selectedProductsList[index].Product.trim()
                        );
                        if (selectedProduct && selectedProduct.Code) {
                          const lotNumbers = productLotNumbersData[selectedProduct.Code] || [];
                          return lotNumbers.map((stockEntry, lotIndex) => {
                            // Calculate sum of all depot Disponible values
                            let sumOfDepots = 0;
                            if (stockEntry && stockEntry.ProductDetails && stockEntry.ProductDetails[0] && stockEntry.ProductDetails[0].Stock) {
                              sumOfDepots = stockEntry.ProductDetails[0].Stock.reduce((sum, depot) => {
                                return sum + (parseFloat(depot.Disponible) || 0);
                              }, 0);
                            }
                            return (
                              <option key={lotIndex} value={stockEntry.LotNumber}>
                                {stockEntry.LotNumber} [{parseFloat(sumOfDepots).toFixed(2)}]
                                {stockEntry.ExperationDate ? ` - Exp: ${new Date(stockEntry.ExperationDate).toLocaleDateString()}` : ''}
                              </option>
                            );
                          });
                        }
                        return null;
                      })()}
                    </select>
                  </div>
                )}

                <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
                  <div>
                    <label
                      htmlFor=""
                      className="text-md font-bold text-navy-700"
                    >
                      Depuis
                    </label>
                    <select
                      label="select Version"
                      className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                      defaultValue=""
                      disabled={
                        depotFormAction === "show" ||
                        selectedProductsList[index].Product === ""
                      }
                      value={selectedProductsList[index]?.FromD?.City}
                      onChange={(e) =>
                        handleFromDepotChange(
                          e,
                          index,
                          selectedProductsList[index].Product
                        )
                      }
                    >
                      <option disabled value="">
                        sélectionner un dépôts
                      </option>
                      {(() => {
                        const selectedProduct = comboBoxData.find(
                          (el) => el.Name === selectedProductsList[index].Product.trim()
                        );
                        
                        // Get stock from selected lot number if available, otherwise use general product stock
                        let stockArray = [];
                        if (selectedProduct && selectedProduct.Code && selectedProductsList[index].LotNumber && selectedProductsList[index].LotNumber !== "") {
                          const lotNumbers = productLotNumbersData[selectedProduct.Code] || [];
                          const selectedLotEntry = lotNumbers.find(
                            (entry) => entry.LotNumber === selectedProductsList[index].LotNumber
                          );
                          if (selectedLotEntry && selectedLotEntry.ProductDetails && selectedLotEntry.ProductDetails[0] && selectedLotEntry.ProductDetails[0].Stock) {
                            stockArray = selectedLotEntry.ProductDetails[0].Stock;
                          }
                        } else if (selectedProduct && selectedProduct.Stock) {
                          stockArray = selectedProduct.Stock;
                        }
                        
                        return stockArray.map((stock, stockIndex) => (
                          <option key={stockIndex} value={stock.City}>
                            {stock.City} [{stock.Disponible}]
                          </option>
                        ));
                      })()}
                    </select>
                  </div>
                  <div>
                    <label
                      htmlFor=""
                      className="text-md font-bold text-navy-700"
                    >
                      À
                    </label>
                    <select
                      label="select Version"
                      className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                      defaultValue=""
                      disabled={
                        depotFormAction === "show" ||
                        selectedProductsList[index].Product === ""
                      }
                      value={selectedProductsList[index]?.ToD?.City}
                      onChange={(e) =>
                        handleToDepotChange(
                          e,
                          index,
                          selectedProductsList[index].Product
                        )
                      }
                    >
                      <option disabled value="">
                        sélectionner un dépôts
                      </option>
                      {(() => {
                        const selectedProduct = comboBoxData.find(
                          (el) => el.Name === selectedProductsList[index].Product.trim()
                        );
                        
                        // Get stock from selected lot number if available, otherwise use general product stock
                        let stockArray = [];
                        if (selectedProduct && selectedProduct.Code && selectedProductsList[index].LotNumber && selectedProductsList[index].LotNumber !== "") {
                          const lotNumbers = productLotNumbersData[selectedProduct.Code] || [];
                          const selectedLotEntry = lotNumbers.find(
                            (entry) => entry.LotNumber === selectedProductsList[index].LotNumber
                          );
                          if (selectedLotEntry && selectedLotEntry.ProductDetails && selectedLotEntry.ProductDetails[0] && selectedLotEntry.ProductDetails[0].Stock) {
                            stockArray = selectedLotEntry.ProductDetails[0].Stock;
                          }
                        } else if (selectedProduct && selectedProduct.Stock) {
                          stockArray = selectedProduct.Stock;
                        }
                        
                        return stockArray.map((stock, stockIndex) => (
                          <option key={stockIndex} value={stock.City}>
                            {stock.City} [{stock.Disponible}]
                          </option>
                        ));
                      })()}
                    </select>
                  </div>
                  <div>
                    <label
                      htmlFor=""
                      className="text-md font-bold text-navy-700"
                    >
                      Quantité
                    </label>
                    <input
                      type="number"
                      min="0"
                      id=""
                      placeholder="Quantité"
                      className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                      value={selectedProductsList[index]?.Quantity}
                      onChange={(e) => handleChangeQuantity(e, index)}
                      disabled={
                        depotFormAction === "show" ||
                        selectedProductsList[index].Product === ""
                      }
                    />
                  </div>
                </div>
              </div>

              {selectedProductsList.length !== 1 && (
                <div className="mt-2 flex items-center justify-center">
                  <FaTrash
                    color="#cf503f"
                    size={30}
                    className="cursor-pointer"
                    onClick={() => handleDeleteProduct(index)}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      <div className="mt-5 flex items-center justify-center">
        <FaPlusCircle
          color="#236571"
          size={50}
          className="cursor-pointer"
          onClick={handleAddNewProduct}
        />
      </div>

      <div className="mt-4 flex items-center gap-6">
        <label className="flex cursor-pointer items-center gap-2 text-sm font-bold text-navy-700">
          <input
            type="radio"
            name="TransfertType"
            value="Marketing support"
            checked={transfertType === "Marketing support"}
            onChange={(e) => setTransfertType(e.target.value)}
          />
          Marketing support
        </label>
        <label className="flex cursor-pointer items-center gap-2 text-sm font-bold text-navy-700">
          <input
            type="radio"
            name="TransfertType"
            value="Essai"
            checked={transfertType === "Essai"}
            onChange={(e) => setTransfertType(e.target.value)}
          />
          Essai
        </label>
      </div>

      <textarea
        placeholder="Saisissez votre commentaire"
        rows={5}
        className="mt-4 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none"
        value={transfertComment}
        onChange={(e) => setTransfertComment(e.target.value)}
      />

      {isLoading ? (
        <div className="flex w-full items-center justify-center">
          <Spinner className="h-12 w-12" />
        </div>
      ) : (
        <div className="mt-5">
          <Button
            variant="gradient"
            color="#236571"
            onClick={() => handleEditeDepot()}
            className="mr-1"
          >
            <span>Transférer</span>
          </Button>
          <Button
            variant="text"
            color="#cf503f"
            onClick={() => handleCancelOp()}
            className="mr-1"
          >
            <span>Annuler</span>
          </Button>
        </div>
      )}
    </form>
  );
}

export default TransfertForm;
